import { Alert, Box } from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";

import { RobotoTypography } from "@/shared/components";
import { RobotoDomainException, RobotoNotFoundException } from "@/shared/http";
import { Goto } from "@/shared/navigation";

import { InviteCard } from "./InviteCard";

interface InviteErrorFallbackProps {
  error: Error;
  onMissing: () => void;
}

export const InviteErrorFallback: React.FC<InviteErrorFallbackProps> = ({
  error,
  onMissing,
}) => {
  let errContent: React.ReactNode;

  React.useEffect(() => {
    if (error instanceof RobotoNotFoundException) {
      onMissing();
    }
  }, [error, onMissing]);

  if (error instanceof RobotoNotFoundException) {
    errContent = (
      <Box>
        <RobotoTypography variant={"body2"}>
          Invite not found. Please contact the person who invited you for more
          details.
        </RobotoTypography>
        <RobotoTypography variant={"body2"}>
          Click <Link to={Goto.route.Home}>here</Link> to return to the main
          screen.
        </RobotoTypography>
      </Box>
    );
  } else if (error instanceof RobotoDomainException) {
    errContent = <Alert severity="error">{error.message}</Alert>;
  } else {
    errContent = (
      <Alert severity="error">
        Something went wrong when opening the invite. Please contact{" "}
        <a href="mailto:support@roboto.ai">support@roboto.ai</a> if this problem
        persists.
      </Alert>
    );
  }

  return <InviteCard>{errContent}</InviteCard>;
};
